module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/triangles.9c0edc66.png";